import ModalIframe from '@/components/ModalIframe'
import vuewidget from './vuewidget'

export default function(dom, opts) {
	let options = {
		...opts,
		vueComponent: ModalIframe,
	}

	let page = vuewidget(dom, options)
	return page
}
